// ADD A SACHET TO CART
var addSachetToCart = function(variantID){

  var list ='';

  if (template == 'search') {
    list = 'search_result';
  } else {
    list = 'category_listing';
  }
    $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { quantity: 1, id: variantID },
        success: function(data) {
          dataLayer.push({
            'event': 'addToCart',
            'ss_event_id': GTM.getGtmRandomString(),
            'addType' : 'cart',
            'ecommerce': {
              'currencyCode': GTM.currency_code,
              'add': {
                'actionField': {

                  'list': list
                },
                'products': [{
                  'name': data.title.replace(/ /g,"_").replace('-','').toLowerCase(),
                  'id': data.sku,
                  'price': data.price,
                  'brand': data.vendor,
                  'category': data.product_type,
                  'variant': data.variant_title.replace(/ /g,"_").replace('-','').toLowerCase(),
                  'quantity': data.quantity
                }]
              }
            }
          });

          //GTM
          dataLayer.push({
            'event': 'GAevent',
            'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '14',
            'eventCategory': 'mini_cart',
            'eventAction': 'add_single_dose',
            'eventLabel': data.product_title.replace(/ /g, "_").replace('-', '').toLowerCase(),
            'sku': data.sku
          });


           $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function(cart) {
                  refreshCart(cart);
                }
            });

        },
        error: function(data) {
            console.log("error");
            console.log(data);
        }
    });
};
// REMOVE A SACHET FROM CART
var removeSachetToCart = function(variantID){
    $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { quantity: 0, id: variantID },
        success: function(data) {
            refreshCart(data);
        },
        error: function(data) {
            console.log("error");
            console.log(data);
        }
    });
};

// CHANGE A SACHET QUANTITY
var updateSachetQuantity = function(sachets){
  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {updates: sachets},
    success: function(data) {
      refreshCart(data);
    },
    error: function(data) {
        console.log("error");
        console.log(data);
    }
  });
};

let freeshippingLimit = 75 * 100;

// SET PROGRESS BAR
var setProgressBar = function(totalCart) {
  let $mobile_menu_progress = $('.mobile_menu__treshold .cart-shipping__wrapper');

  if (typeof $mobile_menu_progress != 'undefined') {

    let result = Math.min(100, Math.round((100 * totalCart) / freeshippingLimit));
    let remainingAmount = Shopify.formatMoney((freeshippingLimit - totalCart), $('body').data('money-format'));

    if (totalCart >= freeshippingLimit) {
      $('.cart-shipping__success').show();
      $('.cart-shipping__num-outer').hide();
    } else {
      $('.cart-shipping__success').hide();
      $('.cart-shipping__num-outer').show();
      $('.cart-shipping__num').text(remainingAmount);
    }

    $('.cart-shipping-threshold__progress').css('width', result + '%');
    if (totalCart >= freeshippingLimit) {
      $('.cart-shipping-threshold__progress').css('border-radius', '8px');
    } else {
      $('.cart-shipping-threshold__progress').css('border-radius', '8px 0px 0px 8px');
    }
    $('.cart-shipping__wrapper').addClass('visible');
  }
};

// SET DISTANCE FROM FREE SHIPPING
var setFreeShippingDistance = function(totalCart){
  let html_content = "";

  if( totalCart >= freeshippingLimit ){
    html_content += "<span>Congrats!</span><span>You get free standard shipping</span>";
  }
  else{
    html_content += "<span>away from free shipping!</span>";
  }
  $('.dav-cart').each( function(){
    $(this).find('.cart_freeshipping .text').html(html_content);
  });
};

//SET ON AND OFF TO SACHETS ADDER/REMOVER
// var evalChecked = function(event){
//     let limit;
//     
//       if(logged_in) {
//         limit = 4;
//       } else {
//         limit = 2;
//       }
//     

//     $('.dav-cart').each( function(){

//       let schetsAdded = $(this).attr("data-sachets");
//       let productsAdded = $(this).attr("data-products");
//       if( productsAdded == 0 ){
//         $(this).find('.sachet_list li input').attr('disabled',true).prop('checked',false);
//       }
//       else{
//         let numerOfSelected = $(this).find('.sachet_list li input:checked').length;
//         if(numerOfSelected < limit) {
//             $(this).find('.sachet_list li input').attr('disabled',false);
//         }
//         else if(numerOfSelected == limit) {
//             $(this).find('.sachet_list li input:not(:checked)').attr('disabled',true);
//         }
//         else if(numerOfSelected > limit) {
//             this.checked = false;
//         }
//       }
//     });
// };

//SET ON AND OFF TO SACHETS ADDER/REMOVER AND SYNC
var syncSachetsState = function($eventTarget, isChecked) {
  let totalSelected = $eventTarget.closest('.dav-cart .sachet_list').find('input:checked')
  let limit;

  
    if(logged_in) {
      limit = 4;
    } else {
      limit = 2;
    }
  

  const variantId = $eventTarget.data('variant_id');
  const $inputList = $('.dav-cart .sachet_list li input[data-variant_id="'+ variantId +'"]');

  $inputList.prop('checked', isChecked);

  $('.dav-cart .sachet_list li input:not(:checked)').attr('disabled', totalSelected.length >= limit );
};

// Click simulate on keyboard navigation
$('.dav-cart .sachet_list li label').keydown(function(event) {
  if(event.which == 13){
    $checbox = $(this).find('input');
    $checbox.prop('checked', !$checbox.prop('checked')).trigger('change');
  }
});

// UPDATE GLOBAL LIMIT AND SYNC
$('.dav-cart .sachet_list li input').change(function(event) {
  let variant_id = $(this).attr("data-variant_id");

  if (this.checked) {
    addSachetToCart(variant_id);
  } else {
    removeSachetToCart(variant_id);
  }

  syncSachetsState($(event.target), this.checked);
});

/*
function checkCartItems(variant_id){
    $.getJSON('/cart.js', function(cart) {
      let limit;
      
        if(logged_in) {
          limit = 4;
        } else {
          limit = 2;
        }
      
        let sachet_count = 0;
        $.each(cart.items, function (index, item) {
            if (item.product_type == "sachet") {
                sachet_count = sachet_count + 1;
            }
        });
        if (sachet_count == limit || sachet_count > limit) {
            removeSachetToCart(variant_id);
            evalChecked();
            $('.dav-cart').find('.sachet_list li input:not(:checked)').attr('disabled',true);
            $('.dav-cart').find('.sachet_list li input[data-variant_id="'+ variant_id +'"]').attr('disabled',true).prop('checked',false);
        } else {
            addSachetToCart(variant_id);
            evalChecked();
        }
    });

};
*/

//FIRST SETUP OF SACHETS ADDER/REMOVER
var setupSachetsData = function(){
  $.getJSON('/cart.js', function(cart) {
      // now have access to Shopify cart object
      let items = cart.items;
      let sachets_counter = 0;
      let products_counter = 0;
      let virtual_products_counter = 0;
      let sachets_to_update = {};
      let sachets_to_remove = {};
      let physical_products_counter = 0;
      let products_not_counted = 'sachet,promogift';
      let cart_physical_products = 0;
      products_not_counted = products_not_counted.split(',');

      let limit;
      
        if(logged_in) {
          limit = 4;
        } else {
          limit = 2;
        }
      

      Object.values(items).forEach(value => {
        if (value.requires_shipping) {
          physical_products_counter ++;
        } else {
          virtual_products_counter ++;
        }

        if (value.product_type == "sachet"){ // se è un campioncino
          sachets_to_remove[value.variant_id] = 0;
          if (sachets_counter >= limit) {
            sachets_to_update[value.variant_id] = 0;
          } else {
            sachets_counter++;
            // Sincronizza lo stato tra tutte le liste
            $('.dav-cart .sachet_list li input[data-variant_id="'+ value.variant_id +'"]').prop('checked', true);
          }
        } else if (products_not_counted.indexOf(value.product_type) == -1) {
          products_counter = products_counter + (1 * value.quantity);
        }
      });

      $('.dav-cart').each( function(){
        $(this).attr("data-products", products_counter).attr("data-sachets", sachets_counter); // segno nei minicart la quantitaì di prodotti e campioncini presenti nel cart
      });

      // hide an empty sachets in case of only virtual products on cart
      if(
        (physical_products_counter == 0 && products_counter > 0) ||
        (virtual_products_counter + sachets_counter == items.length)
        ){
        if(!jQuery.isEmptyObject(sachets_to_remove)) {
          updateSachetQuantity(sachets_to_remove);
        }
        if(items.length > 0){
            $('.sachets, .cart_promo_box').hide();
        } else {
          setTimeout(() => {
            $('.sachets, .cart_promo_box').show();
          }, 1000);
        }
      } else {
        if($('.faq-box__text-sachet-customer.modify-sachet').css('display') === 'block') {
          $('.cart_promo_box').hide();
          $('.sachets').show();
        } else
        { 
          setTimeout(() => {
            $('.sachets, .cart_promo_box').show();
          }, 1000);
        }
      }

      if ( products_counter < 1 && sachets_counter > 0 ){
        emptyCart(); // svuoti carrello
        setupSachetsData(); // Rivaluto tutto
      }
      else{
        if(!jQuery.isEmptyObject(sachets_to_update)) {
          updateSachetQuantity(sachets_to_update);
        }

        // sistemo i campioncini
        let uniqueVariants = new Set();

        $('.sachet_list li input:checked').each(function() {
          uniqueVariants.add($(this).data('variant_id'));
        });
        // Array of unique values from the input list checked
        let checkedSachet =[...uniqueVariants];
        $('.sachet_list li input:not(:checked)').attr('disabled', checkedSachet.length >= limit );
        // evalChecked();
        setFreeShippingDistance( cart.total_price ); // sistemo le spese di spedizione
        setProgressBar(cart.total_price); //update progress bar
      }
  });
};

//Open modal from sachet cart item button
$('body').on('click', '.remove-sachet-cart_item', function () {
  var $this = $(this),
      $modal = $('#cartModal');

  $modal.modal('show');
  $modal.data('productRemoveButton', $this);

  return false;
});

//EXECUTED EACH TIME ORIGINAL BLOCK IS CALLED
$( document ).on( "originalRefreshCart", function() {
  setupSachetsData(); // Rivaluto tutto
});

var removeSachetGtmPush = function () {

  $.ajax({
    url: '/cart',
      success: function () {
        $('.dav-shoppingbag .sachets .sachet_list li div input[type=checkbox]').click(function () {
          var single_dose_name = $(this).attr('product-title');
          var product_sku = $(this).attr('data-product-sku');

          if (this.checked != true) {
            dataLayer.push({
              'event': 'GAevent',
              'ss_event_id': GTM.getGtmRandomString(),
              'eventID': '15',
              'eventCategory': 'cart',
              'eventAction': 'remove_single_dose',
              'eventLabel': single_dose_name.replace(/ /g,"_").replace('-','').toLowerCase(),
              'sku': product_sku
            });
          }

        });

      }
  });
}

/* GTM remove_single_dose */
removeSachetGtmPush();


//EXECUT FIRST SETUP
setupSachetsData();


// sachetListViewMore = {
//     wrap: '.cart-section',
//     breakpoint: 768,
//     limit: {
//         'desk': 8,
//         'mob': 4
//     },
//     init: function(){
//         this.checkVisibility();
//     },
//     checkVisibility: function(){
//         const $list = $(`${this.wrap} .sachet_list`);
//         let $items = $list.find('li'),
//             limitKey = $(window).width() > this.breakpoint ? 'desk' : 'mob' ;

//         if($items.length > this.limit[limitKey]){
//             this.hideExceed($items,this.limit[limitKey]);
//             this.addButton();
//         }
//     },
//     hideExceed: function($items, limit) {
//         $items.filter(`:gt(${(limit-1)})`).slideUp(0);
//     },
//     addButton: function(){
//         $('<div class="sachet_view_more"><a class="btn-secondary" onclick="sachetListViewMore.show(this);" href="javascript:;">View All</a></div>').insertAfter($(`${this.wrap} .sachet_list`));
//     },
//     show: function(btn){
//         const $items = $(`${this.wrap} .sachet_list li`);
//         $items.slideDown(150);
//         $(btn).hide();

//     }
// }
// sachetListViewMore.init();